/*
  SHOP MENU (home page) — Club Partner
  ---------------------------------------------------------------------------
  Rebuilt from the Paritas "Shop" menu. Three tiles open a step-by-step menu:
    Golf clubs: club type → hand → flex → brand
    Club heads: club type → hand → brand
    Shafts:     shaft type → flex → shaft brand → adapter brand
  Every row is a real link into the filter pages with those filters ticked,
  e.g. /collections/all-clubs?club_type=Driver&handedness=Right-Handed&flex=Stiff
  Club number + Flex steps (2026-10-31): "Any number" / "Any flex" is still a
  one-tap row; below it the shopper can tick several and press Continue
  (e.g. 3-Wood + 5-Wood, Stiff + Regular). Paths then carry the ticked values
  joined by commas: club|Fairway Wood|3-Wood,5-Wood|Right-Handed|Stiff,Regular

  WHERE THE NUMBERS COME FROM: the same product index the collection pages
  use (the "custom-filter-chunk" section of /collections/all), cached in the
  browser under the same name the filter's store-wide search uses — so
  visiting the home page also warms up search on the collection pages.
  Labels, groupings and order all come from custom-filter-config.js, so a
  menu row and a filter tick can never disagree.

  Nothing here is shared with the theme's other scripts (everything lives
  inside this one function).
*/
(function () {
  'use strict';
  // The header's Shop dropdown and the page's own Shop menu both load this
  // file; run it once.
  if (window.__cpShopMenuJs) return;
  window.__cpShopMenuJs = true;

  var LINKS = { club: '/collections/all-clubs', shaft: '/collections/shafts', head: '/collections/club-heads' };
  var INDEX_URL = '/collections/all';
  var INDEX_SECTION = 'custom-filter-chunk';      // the section FILE name works without the long id
  var CACHE_KEY = 'cfidx:v4:__all__';             // same key + format as custom-filters.js store-wide search
  var CACHE_TTL_MS = 6 * 60 * 60 * 1000;
  var ANY = '*';
  var NO_TIP = 'No Tip';
  // Club types that get a club-number step (3-Wood, 4 Hybrid, Sand Wedge, 7-Iron …).
  var NUMBERED = { 'Fairway Wood': 1, 'Hybrid': 1, 'Wedge': 1, 'Individual Iron': 1, 'Driving Iron': 1 };
  var NUMBERED_HEADS = { 'Fairway Wood': 1, 'Hybrid': 1 };                          // the Adaptor Brand filter's own label for "no adapter"

  var ITEMS = [
    { key: 'club', label: 'Golf clubs', typeField: 'club_type', typeNoun: function (t) { return plural(t); } },
    { key: 'shaft', label: 'Shafts', typeField: 'shaft_type', typeNoun: function (t) { return t + ' shafts'; } },
    { key: 'head', label: 'Club heads', typeField: 'club_type', typeNoun: function (t) { return t + ' heads'; } }
  ];

  // ---- Small helpers --------------------------------------------------------
  function plural(t) { return /s$/i.test(t) ? t : t + 's'; }
  function cap(s) { s = String(s); return s.charAt(0).toUpperCase() + s.slice(1); }
  function lower(s) { return String(s).toLowerCase(); }
  var ENT = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return ENT[c]; }); }
  function fmt(n) { return Number(n || 0).toLocaleString('en-US'); }
  function handLabel(h) { return h === 'Right-Handed' ? 'Right-handed' : h === 'Left-Handed' ? 'Left-handed' : h; }
  function isPhone() { return window.matchMedia('(max-width: 749px)').matches; }

  // ---- The filter config's rules (same as custom-filters.js) ---------------
  function cfg(key) { var all = window.CustomFilterFieldConfig || {}; return all[key] || {}; }

  var normCache = {};
  function normalizer(key) {
    if (normCache[key]) return normCache[key];
    var c = cfg(key), fixes = c.fixes || {}, groups = c.groups || {};
    var catchAll = !!c.catchAllUnlisted, other = c.otherLabel || 'Other', map = {};
    Object.keys(groups).forEach(function (g) {
      (groups[g] || []).forEach(function (raw) { map[lower(String(raw).trim())] = g; });
    });
    normCache[key] = function (raw) {
      if (!raw) return catchAll ? other : raw;
      var v = String(raw).trim(), vl = lower(v);
      if (fixes[vl]) { v = String(fixes[vl]).trim(); vl = lower(v); }
      if (map[vl]) return map[vl];
      return catchAll ? other : v;
    };
    return normCache[key];
  }
  function prettyCase(value) {
    var raw = String(value == null ? '' : value).trim();
    if (!raw || /[A-Z]/.test(raw)) return raw;
    return raw.replace(/(^|[^a-z0-9'])([a-z])/g, function (m, b, l) { return b + l.toUpperCase(); });
  }
  function otherLabel() { return cfg('brand').otherLabel || 'Other'; }
  function isListedBrand(v) {
    var c = cfg('brand'), k = lower(String(v).trim());
    if (k === lower(otherLabel())) return true;
    return Object.keys(c.groups || {}).some(function (g) { return lower(g) === k; })
      || (c.order || []).some(function (g) { return lower(g) === k; });
  }
  // A brand that falls into "Other" still gets its own name, so the search
  // box can find it (same rule as the Brand filter's search box).
  function unlistedBrand(raw, grouped) {
    if (grouped !== otherLabel() || !raw) return '';
    var r = String(raw).trim(), fixes = cfg('brand').fixes || {};
    var d = fixes[lower(r)] ? String(fixes[lower(r)]).trim() : prettyCase(r);
    return d && !isListedBrand(d) ? d : '';
  }
  // Spellings that differ only in capitals ("Taylormade" / "TaylorMade") count
  // as one row. The filter pages match a link's values ignoring capitals, so
  // one link still ticks both spellings there.
  var canon = {};
  function values(key, raw) {
    if (!raw) return [];
    var n = normalizer(key), out = [], cm = canon[key] || (canon[key] = {});
    String(raw).split(',').forEach(function (s) {
      s = s.trim(); if (!s) return;
      var v = n(s); if (!v) return;
      v = cm[lower(v)] || (cm[lower(v)] = v);
      if (out.indexOf(v) < 0) out.push(v);
    });
    return out;
  }
  function ordered(key, list) {
    var order = (cfg(key).order || []).map(function (x) { return lower(String(x).trim()); });
    return list.slice().sort(function (a, b) {
      var ra = order.indexOf(lower(a)), rb = order.indexOf(lower(b));
      if (ra >= 0 && rb >= 0) return ra - rb;
      if (ra >= 0) return -1;
      if (rb >= 0) return 1;
      return String(a).localeCompare(String(b));
    });
  }

  // ---- Loading the product index -------------------------------------------
  // The saved copy and how old it is. Up to 7 days old it's used straight
  // away so the menu opens instantly (even on the first visit of the day);
  // past 15 minutes it is also re-checked in the background (see ensureData),
  // so a club listed today shows up a second or two later.
  // (The collection pages' search keeps its own 6-hour rule for this copy.)
  var FRESH_MS = 15 * 60 * 1000;
  var MENU_TTL_MS = 7 * 24 * 60 * 60 * 1000;
  function readCache() {
    try {
      var p = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (p && p.ts && p.products && p.products.length && Date.now() - p.ts < MENU_TTL_MS) return { products: p.products, age: Date.now() - p.ts };
    } catch (e) { /* no cache */ }
    return null;
  }
  function writeCache(products) {
    try { localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), products: products })); } catch (e) { /* full: carry on */ }
  }
  function fetchPage(page) {
    return fetch(INDEX_URL + '?section_id=' + INDEX_SECTION + '&page=' + page, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('script[data-custom-filter-index]');
        if (!el) return { data: [], total: 0 };
        return { data: JSON.parse(el.textContent) || [], total: parseInt(el.getAttribute('data-total-pages'), 10) || 1 };
      });
  }
  // All pages are asked for at once. The section tells us roughly how many
  // there are (data-index-pages); if page 1 says there are more, those are
  // fetched too, so a wrong guess only costs time, never products.
  var GUESS_PAGES = 1;
  function loadIndex(fresh) {
    var cached = fresh ? null : readCache();
    if (cached) return Promise.resolve(cached);
    var guess = Math.max(1, Math.min(20, GUESS_PAGES || 1)), early = [];
    for (var g = 1; g <= guess; g++) early.push(fetchPage(g));
    return Promise.all(early).then(function (pages) {
      var total = pages[0].total, more = [];
      for (var p = guess + 1; p <= total; p++) more.push(fetchPage(p));
      return Promise.all(more).then(function (extra) {
        var all = [];
        pages.slice(0, Math.max(1, total)).concat(extra).forEach(function (r) { all = all.concat(r.data); });
        if (all.length) writeCache(all);
        return all;
      });
    });
  }

  // Several menus on one page (the header's Shop dropdown + the page's own
  // menu) share one download instead of each fetching the index.
  var shared = {};
  function loadShared(fresh) {
    var k = fresh ? 'fresh' : 'saved';
    if (!shared[k]) shared[k] = loadIndex(fresh).catch(function (e) { delete shared[k]; throw e; });
    return shared[k];
  }

  // ---- Counting --------------------------------------------------------------
  function node() { return { n: 0, c: {} }; }
  function kindOf(p) { return p.type === 'Shaft' ? 'shaft' : /Head$/i.test(p.type || '') ? 'head' : 'club'; }

  // tree  = the numbers shown on each row.
  // recs  = one small record per product per type, so any mix of ticked club
  //         numbers / flexes can be counted exactly (a club is never counted twice).
  // steps = brand-step numbers, worked out the first time a path is opened (see stepOf).
  function count(products) {
    var tree = {}, recs = {};
    products.forEach(function (p) {
      var it = kindOf(p), mf = p.mf || {};
      var I = tree[it] || (tree[it] = node()); I.n++;
      var types = values(it === 'shaft' ? 'shaft_type' : 'club_type', it === 'shaft' ? mf.shaft_type : mf.club_type);
      var hands = values('handedness', mf.handedness);
      var flexes = values('flex', mf.flex);
      var gb = normalizer('brand')(p.vendor), ub = unlistedBrand(p.vendor, gb);
      var tips = it === 'shaft' ? values('shaft_tip_brand', mf.shaft_tip_brand) : null;
      types.forEach(function (ty) {
        var T = I.c[ty] || (I.c[ty] = node()); T.n++;
        var numbered = it === 'club' ? NUMBERED[ty] : it === 'head' ? NUMBERED_HEADS[ty] : 0;
        var nums = numbered ? values('club_number', mf.club_number) : [];
        // [club numbers, hands, flexes, brand, brand inside Other, adapters, price in cents]
        (recs[it + '|' + ty] || (recs[it + '|' + ty] = [])).push([nums, hands, it === 'head' ? [] : flexes, gb, ub,
          tips ? (tips.length ? tips : [NO_TIP]) : null, p.price]);
        if (it === 'shaft') {
          flexes.forEach(function (f) { (T.c[f] || (T.c[f] = node())).n++; });
          return;
        }
        // Clubs: type → (club number) → hand → flex.  Heads: type → (club number) → hand.
        // '*' = any number; a club with no number counts under '*' only.
        T.k = T.k || {};
        [ANY].concat(nums).forEach(function (nk) {
          var N = T.k[nk] || (T.k[nk] = node()); N.n++;
          hands.forEach(function (h) {
            var H = N.c[h] || (N.c[h] = node()); H.n++;
            if (it === 'club') flexes.forEach(function (f) { (H.c[f] || (H.c[f] = node())).n++; });
          });
        });
      });
    });
    return { tree: tree, recs: recs, steps: {} };
  }
  // A path segment: '*' = any, otherwise one value or several joined by commas
  // (values never contain commas — values() splits on them).
  function setOf(seg) { return !seg || seg === ANY ? null : String(seg).split(','); }
  function hasAny(arr, set) {
    if (!set) return true;
    for (var i = 0; i < arr.length; i++) if (set.indexOf(arr[i]) >= 0) return true;
    return false;
  }
  function matchRecs(counts, kind, t, ns, h, fs) {
    return (counts.recs[kind + '|' + t] || []).filter(function (r) {
      return hasAny(r[0], ns) && (h == null || r[1].indexOf(h) >= 0) && hasAny(r[2], fs);
    });
  }
  // Brand-step numbers for a path like  club|Fairway Wood|3-Wood,5-Wood|Right-Handed|Stiff,Regular
  //                                      head|Hybrid|*|Left-Handed      shaft|Driver|Stiff
  function stepOf(counts, key) {
    if (counts.steps[key]) return counts.steps[key];
    var p = key.split('|'), kind = p[0], t = p[1], list;
    if (kind === 'shaft') list = matchRecs(counts, kind, t, null, null, setOf(p[2]));
    else list = matchRecs(counts, kind, t, setOf(p[2]), p[3] == null ? null : p[3], kind === 'club' ? setOf(p[4]) : null);
    var st = { n: 0, g: {}, u: {}, t: {}, pairs: {}, items: [] };
    list.forEach(function (r) {
      var gb = r[3], ub = r[4], tl = r[5];
      st.n++;
      // [brand, brand inside Other, adapters, price in cents]: lets the Search button count exactly
      // what the ticked brands, adapters and price range will return.
      st.items.push([gb, ub, tl, r[6]]);
      st.g[gb] = (st.g[gb] || 0) + 1;
      if (ub) st.u[ub] = (st.u[ub] || 0) + 1;
      if (!tl) return;
      tl.forEach(function (x) { st.t[x] = (st.t[x] || 0) + 1; });
      [gb, ub].forEach(function (b) {
        if (!b) return;
        var pb = st.pairs[b] || (st.pairs[b] = {});
        tl.forEach(function (x) { pb[x] = (pb[x] || 0) + 1; });
      });
    });
    return (counts.steps[key] = st);
  }
  // Row numbers (hand → flex) for several ticked club numbers at once.
  function nodeFor(counts, kind, t, ns) {
    var N = node();
    matchRecs(counts, kind, t, ns, null, null).forEach(function (r) {
      N.n++;
      r[1].forEach(function (h) {
        var H = N.c[h] || (N.c[h] = node()); H.n++;
        if (kind === 'club') r[2].forEach(function (f) { (H.c[f] || (H.c[f] = node())).n++; });
      });
    });
    return N;
  }

  // ---- Building the menu ------------------------------------------------------
  function href(kind, fields) {
    var parts = [];
    Object.keys(fields).forEach(function (k) {
      [].concat(fields[k]).forEach(function (v) { parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(v)); });
    });
    return LINKS[kind] + (parts.length ? '?' + parts.join('&') : '');
  }
  var GO = '<span class="cpm-go" aria-hidden="true">&rsaquo;</span>';
  function row(o) {
    return '<a class="cpm-item" href="' + esc(href(o.kind, o.fields)) + '"'
      + (o.open ? ' data-open="' + esc(o.open) + '"' : '')
      + (o.brand ? ' data-brand="' + esc(o.brand) + '" data-kind="' + esc(o.kind) + '" data-fields="' + esc(JSON.stringify(o.fields)) + '" data-title="' + esc(o.title) + '"' : '')
      + (o.v != null ? ' data-v="' + esc(o.v) + '"' : '') + (o.any ? ' data-any="1"' : '')
      + '><span class="cpm-l">' + esc(o.label) + '</span><span class="cpm-n">' + fmt(o.n) + '</span>' + GO + '</a>';
  }
  function col(level, key, head, kind, allFields, allLabel, n, body, sub, extra) {
    return '<div class="cpm-col" data-level="' + level + '" data-key="' + esc(key) + '"' + (extra || '') + ' hidden>'
      + (level > 2 ? '<button type="button" class="cpm-back" data-back="' + (level - 1) + '">&lsaquo; Back</button>' : '')
      + '<div class="cpm-h">' + esc(head) + '</div>'
      + '<a class="cpm-all" href="' + esc(href(kind, allFields)) + '">Shop all ' + esc(allLabel) + ' (' + fmt(n) + ')</a>'
      + (sub ? '<div class="cpm-sub">' + esc(sub) + '</div>' : '') + body + '</div>';
  }
  // Club number + Flex steps: "Any …" stays a one-tap row; underneath, tick
  // one or more and press Continue. list = [[value, label, count], …]
  function selBlock(list) {
    return '<div class="cpm-or">or tick one or more</div><div class="cpm-blist cpm-sel">' + list.map(function (x) {
      return '<label class="cpm-b"><input type="checkbox" value="' + esc(x[0]) + '" data-n="' + Number(x[2]) + '">'
        + '<span>' + esc(x[1]) + '</span><span class="cpm-n">' + fmt(x[2]) + '</span></label>';
    }).join('') + '</div><button type="button" class="cp-btn cp-btn--green cpm-bgo cpm-cont" disabled>Continue</button>';
  }
  function selAttrs(sel, kind, t, fields, title) {
    return ' data-sel="' + sel + '" data-kind="' + kind + '" data-type="' + esc(t) + '" data-f="' + esc(JSON.stringify(fields)) + '" data-t="' + esc(title) + '"';
  }
  function listJoin(list, word) {
    return list.length < 2 ? list.join('') : list.slice(0, -1).join(', ') + ' ' + word + ' ' + list[list.length - 1];
  }
  // Golf clubs: the "Which hand?" column for one club-number choice (nk = '*',
  // one number, or several joined by commas), plus a Flex column per hand.
  function clubHandCols(t, nk, nf, nNoun, N, lv) {
    var out = [], hands = ordered('handedness', Object.keys(N.c));
    out.push(col(lv, 'club|' + t + '|' + nk, nNoun, 'club', nf, lower(nNoun), N.n, hands.map(function (h) {
      var H = N.c[h], fields = Object.assign({}, nf, { handedness: h });
      var title = handLabel(h) + ' ' + lower(nNoun), path = 'club|' + t + '|' + nk + '|' + h;
      var flexes = ordered('flex', Object.keys(H.c));
      if (!flexes.length) return row({ kind: 'club', fields: fields, label: handLabel(h), n: H.n, brand: path + '|' + ANY, title: title, v: h });
      out.push(col(lv + 1, path, cap(title), 'club', fields, lower(title), H.n,
        row({ kind: 'club', fields: fields, label: 'Any flex', n: H.n, brand: path + '|' + ANY, title: title, any: 1 })
        + selBlock(flexes.map(function (f) { return [f, f, H.c[f].n]; })), 'Flex', selAttrs('flex', 'club', t, fields, title)));
      return row({ kind: 'club', fields: fields, label: handLabel(h), n: H.n, open: path, v: h });
    }).join(''), 'Which hand?'));
    return out.join('');
  }
  function headHandCol(t, nk, nf, hNoun, N, lv) {
    var hh = ordered('handedness', Object.keys(N.c));
    return col(lv, 'head|' + t + '|' + nk, hNoun, 'head', nf, lower(hNoun), N.n, hh.map(function (h) {
      return row({ kind: 'head', fields: Object.assign({}, nf, { handedness: h }), label: handLabel(h), n: N.c[h].n,
        brand: 'head|' + t + '|' + nk + '|' + h, title: handLabel(h) + ' ' + lower(hNoun), v: h });
    }).join(''), 'Which hand?');
  }

  function hasNums(T) { return Object.keys((T && T.k) || {}).some(function (k) { return k !== ANY; }); }
  function build(counts) {
    var tree = counts.tree, cols = [];
    ITEMS.forEach(function (m) {
      var I = tree[m.key];
      if (!I || !I.n) return;
      var types = ordered(m.typeField, Object.keys(I.c));
      cols.push(col(2, m.key, m.label, m.key, {}, lower(m.label), I.n, types.map(function (t) {
        var f = {}; f[m.typeField] = t;
        var numbered = m.key === 'club' ? NUMBERED[t] : m.key === 'head' ? NUMBERED_HEADS[t] : 0;
        var opens = m.key !== 'shaft' && !(numbered && hasNums(I.c[t])) ? m.key + '|' + t + '|' + ANY : m.key + '|' + t;
        return row({ kind: m.key, fields: f, label: m.typeNoun(t), n: I.c[t].n, open: opens, v: t });
      }).join('')));
      types.forEach(function (t) {
        var T = I.c[t], base = {}, noun = m.typeNoun(t);
        base[m.typeField] = t;
        if (m.key === 'shaft') {
          var sf = ordered('flex', Object.keys(T.c));
          cols.push(col(3, 'shaft|' + t, noun, 'shaft', base, lower(noun), T.n,
            row({ kind: 'shaft', fields: base, label: 'Any flex', n: T.n, brand: 'shaft|' + t + '|' + ANY, title: lower(noun), any: 1 })
            + (sf.length ? selBlock(sf.map(function (f) { return [f, f, T.c[f].n]; })) : ''),
            'Flex', selAttrs('flex', 'shaft', t, base, lower(noun))));
          return;
        }
        // Club number column first for numbered types ("Any number" + tick boxes).
        // Only the "Any number" path is built now; ticked numbers build theirs on Continue.
        var isHead = m.key === 'head';
        var numbered = isHead ? NUMBERED_HEADS[t] : NUMBERED[t];
        var nums = numbered ? ordered('club_number', Object.keys(T.k || {}).filter(function (k) { return k !== ANY; })) : [];
        var lv = 3;
        if (nums.length) {
          cols.push(col(3, m.key + '|' + t, noun, m.key, base, lower(noun), T.n,
            row({ kind: m.key, fields: base, label: 'Any number', n: T.n, open: m.key + '|' + t + '|' + ANY, any: 1 })
            + selBlock(nums.map(function (nk) { return [nk, isHead ? nk + ' heads' : nk, T.k[nk].n]; })),
            'Club number', selAttrs('num', m.key, t, base, noun)));
          lv = 4;
        }
        var N = T.k && T.k[ANY];
        if (!N) return;
        cols.push(isHead ? headHandCol(t, ANY, base, noun, N, lv) : clubHandCols(t, ANY, base, noun, N, lv));
      });
    });
    return cols.join('')
      + '<div class="cpm-col cpm-pick" data-step="brand" hidden></div>'
      + '<div class="cpm-col cpm-pick" data-step="tip" hidden></div>'
      + '<div class="cpm-hint" aria-hidden="true">Pick one to narrow it down, or tap “Shop all” at any step.</div>';
  }

  // ---- Behaviour ----------------------------------------------------------------
  function start(menu) {
    var panel = menu.querySelector('.cpm-panel');
    var counts = null, loading = null, failed = false, pick = null, waitingTile = null;
    var bcol, tcol, cols;
    var noScroll = menu.hasAttribute('data-no-scroll');
    if (noScroll) panel.setAttribute('tabindex', '-1');

    function apply(c) {
      counts = c; pending = null;
      panel.innerHTML = build(counts);
      bcol = panel.querySelector('.cpm-pick[data-step=brand]');
      tcol = panel.querySelector('.cpm-pick[data-step=tip]');
      cols = panel.querySelectorAll('.cpm-col');
      ITEMS.forEach(function (m) {
        var el = menu.querySelector('[data-count="' + m.key + '"]');
        var n = counts.tree[m.key] ? counts.tree[m.key].n : 0;
        if (el && n) el.innerHTML = fmt(n) + ' for sale &rarr;';
      });
    }
    // Background re-check of a saved copy that's more than 15 minutes old.
    // New numbers go in straight away if the menu is closed, otherwise the
    // next time a tile is tapped, so nothing changes under someone's finger.
    var pending = null;
    function refresh() {
      loadShared(true).then(function (products) {
        if (!products || !products.length) return;
        var c = count(products);
        if (counts && JSON.stringify([c.tree, c.recs]) === JSON.stringify([counts.tree, counts.recs])) return;
        if (panel.hidden || !counts) apply(c); else pending = c;
      }).catch(function () { /* keep what we have */ });
    }
    function ensureData() {
      if (counts || failed) return Promise.resolve(counts);
      if (!loading) {
        loading = loadShared(false).then(function (got) {
          var products = Array.isArray(got) ? got : got && got.products;
          if (!products || !products.length) throw new Error('empty');
          apply(count(products));
          if (!Array.isArray(got) && got.age > FRESH_MS) setTimeout(refresh, 1500);
          return counts;
        }).catch(function () { failed = true; return null; });
      }
      return loading;
    }

    function level(el) { var c = el.closest('.cpm-col'); return c ? Number(c.getAttribute('data-level')) : 1; }
    // Desktop shows 4 columns. A path deeper than that (club number adds one)
    // slides left, so the newest column is always on screen.
    function depth(d) {
      menu.setAttribute('data-depth', String(d));
      var off = Math.max(0, d - 5);
      menu.setAttribute('data-slid', off ? '1' : '0');
      for (var i = 0; i < cols.length; i++) {
        var lv = Number(cols[i].getAttribute('data-level'));
        cols[i].classList.toggle('cpm-behind', lv < d);
        cols[i].classList.toggle('cpm-off', lv - 1 - off < 1);
        cols[i].classList.toggle('cpm-first', lv - 1 - off === 1);
        cols[i].style.gridColumn = String(Math.max(1, lv - 1 - off));
      }
    }
    function hideAbove(lv) {
      for (var i = 0; i < cols.length; i++) if (Number(cols[i].getAttribute('data-level')) > lv) cols[i].hidden = true;
      var on = panel.querySelectorAll('.cpm-item.on');
      for (var j = 0; j < on.length; j++) if (level(on[j]) >= lv) on[j].classList.remove('on');
    }
    function open(lv, key) {
      hideAbove(lv - 1);
      for (var i = 0; i < cols.length; i++) {
        if (Number(cols[i].getAttribute('data-level')) === lv && cols[i].hasAttribute('data-key')) cols[i].hidden = cols[i].getAttribute('data-key') !== key;
      }
      clearSel(findCol(key));                       // a step opened fresh starts with nothing ticked
    }
    function mark(link, sel) {
      var scope = link.closest('.cpm-col') || menu.querySelector('.cpm-tiles');
      var on = scope.querySelectorAll(sel + '.on');
      for (var i = 0; i < on.length; i++) on[i].classList.remove('on');
      link.classList.add('on');
    }
    // Bring the open menu to the middle of the screen, every time a tile or
    // a row is tapped. Whole menu (tiles + list) if it fits, otherwise the
    // list on its own, otherwise the top of the list just under the header.
    function headerOffset() {
      // Only counts the header when it really stays pinned while scrolling
      // (Club Partner's scrolls away, so this is normally 0).
      var h = document.querySelector('.section-header');
      if (!h) return 0;
      var r = h.getBoundingClientRect();
      return window.scrollY > r.height && r.top >= -1 && r.bottom > 0 ? r.bottom : 0;
    }
    function focus() {
      // Inside the header dropdown / phone menu the page itself mustn't jump.
      // Just make sure the top of the list is visible in that box.
      if (noScroll) {
        var box0 = menu.closest('.mega-menu__content, .menu-drawer__inner-submenu');
        if (!box0) return;
        var pr = panel.getBoundingClientRect(), br = box0.getBoundingClientRect();
        if (pr.top < br.top || pr.top > br.bottom - 80) box0.scrollTop += pr.top - br.top - 8;
        return;
      }
      // Centre the menu box itself (not the tiles) in the screen. If the box
      // is taller than the screen, put its top just below the header instead.
      var top = headerOffset(), gap = isPhone() ? 8 : 16;
      var room = window.innerHeight - top;
      var box = panel.getBoundingClientRect();
      var y = box.height <= room - gap * 2
        ? box.top + box.height / 2 - (top + room / 2)          // its middle on the screen's middle
        : box.top - top - gap;
      if (Math.abs(y) < 12) return;                            // already there: don't twitch
      window.scrollTo({ top: Math.max(0, window.scrollY + y), behavior: 'smooth' });
    }

    // Brand + adapter steps --------------------------------------------------------
    function ticked(c) { return !c || c.hidden ? [] : [].slice.call(c.querySelectorAll('input[type=checkbox]:checked')); }
    function sum(list) { var n = 0; list.forEach(function (x) { n += Number(x.getAttribute('data-n')) || 0; }); return n; }
    // The ticked brands, dropping a brand inside "Other" when Other itself is ticked (no double count).
    function brandVals() {
      var b = ticked(bcol), other = b.some(function (x) { return x.value === otherLabel(); });
      return b.filter(function (x) { return !(other && x.closest('.cpm-b').classList.contains('unl')); });
    }
    function tipList(st) {
      var picked = brandVals(), acc = {};
      if (!picked.length) acc = st.t;
      else picked.forEach(function (b) {
        var pb = st.pairs[b.value] || {};
        Object.keys(pb).forEach(function (t) { acc[t] = (acc[t] || 0) + pb[t]; });
      });
      return ordered('shaft_tip_brand', Object.keys(acc).filter(function (t) { return t !== NO_TIP; }))
        .concat(acc[NO_TIP] ? [NO_TIP] : [])
        .map(function (t) { return [t, acc[t]]; });
    }
    function tipsWorth(st) { return tipList(st).some(function (x) { return x[0] !== NO_TIP; }); }
    var aliasOf = function () { return ''; };
    function checkRows(list, name, cls) {
      return list.map(function (x) {
        var label = name === 'tip' && x[0] === NO_TIP ? 'No adapter' : x[0];
        return '<label class="cpm-b ' + cls(x) + '"' + (cls(x) === 'unl' ? ' hidden' : '') + ' data-a="' + esc(name === 'brand' ? aliasOf(x[0]) : '') + '"><input type="checkbox" value="' + esc(x[0]) + '" data-n="' + Number(x[1]) + '">'
          + '<span>' + esc(label) + '</span><span class="cpm-n">' + fmt(x[1]) + '</span></label>';
      }).join('');
    }
    function brandRows(st) {
      var o = otherLabel();
      var g = Object.keys(st.g).filter(function (b) { return b !== o; }).sort(function (a, b) { return a.localeCompare(b); });
      var list = g.map(function (b) { return [b, st.g[b], 'grp']; });
      // Every spelling grouped into a brand finds it ("vokey" finds Titleist).
      var c = cfg('brand'), alias = {};
      Object.keys(c.groups || {}).forEach(function (k) { alias[k] = (c.groups[k] || []).join(' '); });
      Object.keys(c.fixes || {}).forEach(function (k) { var v = c.fixes[k]; alias[v] = (alias[v] || '') + ' ' + k; });
      aliasOf = function (b) { return alias[b] || ''; };
      if (st.g[o]) list.push([o, st.g[o], 'oth']);
      Object.keys(st.u).sort(function (a, b) { return a.localeCompare(b); }).forEach(function (b) { list.push([b, st.u[b], 'unl']); });
      return checkRows(list, 'brand', function (x) { return x[2]; });
    }
    function step(c, lv, o) {
      c.innerHTML = '<button type="button" class="cpm-back" data-back="' + (lv - 1) + '">&lsaquo; Back</button>'
        + '<div class="cpm-h">' + esc(o.head) + '</div><div class="cpm-crumb">' + esc(cap(o.crumb)) + '</div>'
        + (o.note ? '<p class="cpm-note">' + esc(o.note) + '</p>' : '')
        + (o.search ? '<input type="search" class="cpm-bsearch" placeholder="' + esc(o.search) + '" aria-label="' + esc(o.search) + '" autocomplete="off">' : '')
        + '<div class="cpm-blist">' + o.rows + '<p class="cpm-bnone" hidden>Nothing matches that.</p></div>'
        + (o.price ? '<div class="cpm-price" role="group" aria-label="Price range"><span class="cpm-price-h">Price</span>'
          + '<label class="cpm-price-box"><span aria-hidden="true">$</span><input type="number" inputmode="numeric" min="0" step="1" placeholder="Min" aria-label="Lowest price" data-price="min" value="' + (price.min == null ? '' : price.min) + '"></label>'
          + '<span class="cpm-price-to">to</span>'
          + '<label class="cpm-price-box"><span aria-hidden="true">$</span><input type="number" inputmode="numeric" min="0" step="1" placeholder="Max" aria-label="Highest price" data-price="max" value="' + (price.max == null ? '' : price.max) + '"></label></div>' : '')
        + '<button type="button" class="cp-btn cp-btn--green cpm-bgo"></button>'
        + '<button type="button" class="cpm-bclear" hidden>Clear</button>';
      c.setAttribute('data-level', String(lv));
      c.hidden = false;
    }
    // The price range typed in the last step, in whole dollars (null = no limit).
    var price = { min: null, max: null };
    function priceOn() { return price.min != null || price.max != null; }
    // Exactly how many clubs the ticked brands, adapters and price range will show.
    function exact(st, useTips) {
      var bv = {}, tv = {}, nb = 0, nt = 0;
      brandVals().forEach(function (x) { bv[x.value] = 1; nb++; });
      if (useTips) ticked(tcol).forEach(function (x) { tv[x.value] = 1; nt++; });
      var lo = price.min == null ? null : price.min * 100, hi = price.max == null ? null : price.max * 100;
      var n = 0;
      st.items.forEach(function (it) {
        if (nb && !bv[it[0]] && !(it[1] && bv[it[1]])) return;
        if (nt && !(it[2] || []).some(function (t) { return tv[t]; })) return;
        if (lo != null && it[3] < lo) return;
        if (hi != null && it[3] > hi) return;
        n++;
      });
      return n;
    }
    function label(nPicked, what, n) {
      if (nPicked) return 'Search ' + (nPicked === 1 ? 'this ' + what : 'these ' + nPicked + ' ' + what + 's') + ' (' + fmt(n) + ')';
      return (priceOn() ? 'Search (' : 'Search all (') + fmt(n) + ')';
    }
    function buttons() {
      var st = pick && stepOf(counts, pick.key);
      if (!st) return;
      var b = ticked(bcol), bb = bcol.querySelector('.cpm-bgo');
      var hasTips = pick.kind === 'shaft' && tipsWorth(st), what = pick.kind === 'shaft' ? 'shaft brand' : 'brand';
      if (hasTips) bb.textContent = b.length ? 'Next: adapter (' + b.length + ' picked)' : 'Next: adapter brand';
      else bb.textContent = label(b.length, what, exact(st, false));
      bb.disabled = !hasTips && exact(st, false) === 0;
      bcol.querySelector('.cpm-bclear').hidden = !b.length && !priceOn();
      var tb = tcol.querySelector('.cpm-bgo');
      if (tb && !tcol.hidden) {
        var t = ticked(tcol), n = exact(st, true);
        tb.textContent = t.length ? label(t.length, 'adapter', n) : (b.length ? 'Search these shafts (' + fmt(n) + ')' : label(0, '', n));
        tb.disabled = n === 0;
        tcol.querySelector('.cpm-bclear').hidden = !t.length && !priceOn();
      }
    }
    function brandStep(link) {
      var fields = {};
      try { fields = JSON.parse(link.getAttribute('data-fields') || '{}'); } catch (e) { return false; }
      return brandStepFrom(link.getAttribute('data-brand'), link.getAttribute('data-kind'), fields, link.getAttribute('data-title') || '', level(link));
    }
    function brandStepFrom(key, kind, fields, title, lv) {
      var st = stepOf(counts, key);
      if (!st.n) return false;
      pick = { key: key, kind: kind, fields: fields, title: title };
      price = { min: null, max: null };
      tcol.hidden = true; tcol.innerHTML = '';
      step(bcol, lv + 1, {
        head: pick.kind === 'shaft' ? 'Shaft brand' : 'Brand',
        crumb: pick.title + ' · tick as many as you like',
        search: pick.kind === 'shaft' ? 'Search shaft brands' : 'Search brands',
        rows: brandRows(st),
        price: !(pick.kind === 'shaft' && tipsWorth(st))      // the price boxes go on the LAST step
      });
      buttons();
      return true;
    }
    function tipStep() {
      var st = stepOf(counts, pick.key);
      step(tcol, Number(bcol.getAttribute('data-level')) + 1, {
        head: 'Adapter brand',
        crumb: pick.title,
        note: 'Which club brand does the shaft’s adapter (tip) fit? Pick the brand of the club you’ll put it in.',
        rows: checkRows(tipList(st), 'tip', function () { return 'grp'; }),
        price: true
      });
      buttons();
      depth(Number(tcol.getAttribute('data-level')));
    }
    // Club number / Flex tick boxes -------------------------------------------------
    function selVals(c) { return [].slice.call(c.querySelectorAll('.cpm-sel input:checked')).map(function (x) { return x.value; }); }
    function selButton(c) {
      var b = c.querySelector('.cpm-cont');
      if (!b) return;
      var vals = selVals(c);
      if (!vals.length) { b.disabled = true; b.textContent = 'Continue'; return; }
      var kind = c.getAttribute('data-kind'), t = c.getAttribute('data-type');
      var n = c.getAttribute('data-sel') === 'num'
        ? matchRecs(counts, kind, t, vals, null, null).length
        : stepOf(counts, c.getAttribute('data-key') + '|' + vals.join(',')).n;
      b.disabled = n === 0;
      b.textContent = 'Continue (' + fmt(n) + ')';
    }
    function clearSel(c) {
      if (!c || !c.querySelector('.cpm-sel')) return;
      c.querySelectorAll('.cpm-sel input:checked').forEach(function (x) { x.checked = false; });
      selButton(c);
    }
    function findCol(key) {
      for (var i = 0; i < cols.length; i++) if (cols[i].getAttribute('data-key') === key) return cols[i];
      return null;
    }
    function proceed(c) {
      var vals = selVals(c);
      if (!vals.length) return;
      var lv = Number(c.getAttribute('data-level')), kind = c.getAttribute('data-kind'), t = c.getAttribute('data-type');
      var key = c.getAttribute('data-key'), title = c.getAttribute('data-t') || '', fields = {};
      try { fields = JSON.parse(c.getAttribute('data-f') || '{}'); } catch (e) { return; }
      var joined = vals.join(',');
      if (c.getAttribute('data-sel') === 'num') {
        // Ticked club numbers → a "Which hand?" column for exactly those numbers.
        var nkey = key + '|' + joined;
        if (!findCol(nkey)) {
          var nf = Object.assign({}, fields, { club_number: vals.length === 1 ? vals[0] : vals });
          var N = nodeFor(counts, kind, t, vals);
          var html = kind === 'head'
            ? headHandCol(t, joined, nf, listJoin(vals, '&') + ' heads', N, lv + 1)
            : clubHandCols(t, joined, nf, listJoin(vals.map(plural), '&'), N, lv + 1);
          bcol.insertAdjacentHTML('beforebegin', html);
          cols = panel.querySelectorAll('.cpm-col');
        }
        open(lv + 1, nkey);
        depth(lv + 1);
        focus();
        return;
      }
      // Ticked flexes → the Brand step.
      hideAbove(lv);
      var f = Object.assign({}, fields, { flex: vals.length === 1 ? vals[0] : vals });
      var ttl = kind === 'shaft' ? listJoin(vals, 'or') + ' ' + title : title + ', ' + listJoin(vals, 'or') + ' flex';
      if (!brandStepFrom(key + '|' + joined, kind, f, ttl, lv)) { window.location.href = href(kind, f); return; }
      depth(lv + 1);
      focus();
    }
    function go() {
      var f = Object.assign({}, pick.fields);
      var b = ticked(bcol).map(function (x) { return x.value; });
      var t = ticked(tcol).map(function (x) { return x.value; });
      if (b.length) f.brand = b;
      if (t.length) f.shaft_tip_brand = t;
      if (price.min != null) f.price_min = price.min;
      if (price.max != null) f.price_max = price.max;
      window.location.href = href(pick.kind, f);
    }

    // Tapping the tile that's already open folds the menu back up to just the tiles.
    function closeMenu() {
      waitingTile = null;
      panel.hidden = true;
      var on = menu.querySelectorAll('.cpm-tile.on');
      for (var i = 0; i < on.length; i++) on[i].classList.remove('on');
      if (cols) { hideAbove(1); depth(1); } else menu.setAttribute('data-depth', '1');
    }
    function openTile(tile) {
      if (tile.classList.contains('on') && !panel.hidden) { closeMenu(); return; }
      mark(tile, '.cpm-tile');
      panel.hidden = false;
      if (!counts) {
        waitingTile = tile;
        panel.innerHTML = '<div class="cpm-loading">Loading…</div>';
        ensureData().then(function (c) {
          if (waitingTile !== tile) return;
          if (!c) { window.location.href = tile.getAttribute('href'); return; }  // couldn't count: just go to the collection
          tile.classList.remove('on');              // so the re-open below opens rather than closes
          openTile(tile);
        });
        return;
      }
      waitingTile = null;
      if (pending) apply(pending);                 // newer numbers arrived while the menu was open
      open(2, tile.getAttribute('data-open'));
      depth(2);
      if (menu.getAttribute('data-here') === tile.getAttribute('data-open')) walkHere(tile.getAttribute('data-open'));
      focus();
    }

    // On a collection page, open the menu at the filters already in the page address
    // (e.g. Drivers › Right-handed › Stiff › Brand with Ping still ticked).
    function walkHere(kind) {
      var q;
      try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
      var one = function (k) { var v = q.getAll(k); return v.length === 1 ? v[0] : null; };
      var t = one(kind === 'shaft' ? 'shaft_type' : 'club_type');
      if (!t) return;
      var h = one('handedness'), nums = q.getAll('club_number').map(lower), flexes = q.getAll('flex').map(lower);
      function byValue(c, v) {
        var a = c.querySelectorAll('a.cpm-item[data-v]');
        for (var j = 0; j < a.length; j++) if (lower(a[j].getAttribute('data-v')) === lower(v)) return a[j];
        return null;
      }
      // Step through the menu one column at a time: type, club number(s), hand, flex(es).
      for (var guard = 0; guard < 8; guard++) {
        if (!bcol.hidden) break;
        var deep = null;
        for (var i = 0; i < cols.length; i++) {
          if (cols[i].hidden || cols[i].classList.contains('cpm-pick')) continue;
          if (!deep || Number(cols[i].getAttribute('data-level')) > Number(deep.getAttribute('data-level'))) deep = cols[i];
        }
        if (!deep) return;
        var sel = deep.getAttribute('data-sel'), hit = null;
        if (deep.getAttribute('data-level') === '2') hit = byValue(deep, t);
        else if (sel) {
          var want = sel === 'num' ? nums : flexes;
          if (want.length) {
            var any = false;
            deep.querySelectorAll('.cpm-sel input').forEach(function (x) { if (want.indexOf(lower(x.value)) >= 0) { x.checked = true; any = true; } });
            if (!any) return;
            selButton(deep);
            hit = deep.querySelector('.cpm-cont');
          } else hit = deep.querySelector('a.cpm-item[data-any]');
        } else hit = h ? byValue(deep, h) : null;
        if (!hit || hit.disabled) return;
        hit.click();
      }
      if (!bcol.hidden) {
        // The brand step: re-tick the brands and price range already on the page.
        var brands = q.getAll('brand').map(lower);
        bcol.querySelectorAll('input[type=checkbox]').forEach(function (x) {
          if (brands.indexOf(lower(x.value)) >= 0) { x.checked = true; x.closest('.cpm-b').hidden = false; }
        });
        var lo = parseFloat(q.get('price_min')), hi = parseFloat(q.get('price_max'));
        price = { min: isNaN(lo) ? null : Math.round(lo), max: isNaN(hi) ? null : Math.round(hi) };
        var pmin = panel.querySelector('[data-price=min]'), pmax = panel.querySelector('[data-price=max]');
        if (pmin) pmin.value = price.min == null ? '' : price.min;
        if (pmax) pmax.value = price.max == null ? '' : price.max;
        buttons();
      }
    }

    menu.addEventListener('click', function (e) {
      var tile = e.target.closest('a.cpm-tile[data-open]');
      if (tile) { e.preventDefault(); openTile(tile); return; }
      if (!counts) return;
      var back = e.target.closest('[data-back]');
      if (back) {
        var to = Number(back.getAttribute('data-back')); hideAbove(to); depth(to);
        // The Back button just hid itself. Hand focus to something still showing,
        // or the header dropdown thinks the shopper clicked away and closes.
        if (noScroll) { var keep = panel.querySelector('.cpm-col:not([hidden]) .cpm-item.on'); (keep || panel).focus({ preventScroll: true }); }
        focus(); return;
      }
      var clr = e.target.closest('.cpm-bclear');
      if (clr) {
        clr.closest('.cpm-col').querySelectorAll('input[type=checkbox]').forEach(function (x) { x.checked = false; });
        clr.closest('.cpm-col').querySelectorAll('[data-price]').forEach(function (x) { x.value = ''; });
        price = { min: null, max: null };
        buttons(); return;
      }
      var cont = e.target.closest('.cpm-cont');
      if (cont) { if (!cont.disabled) proceed(cont.closest('.cpm-col')); return; }
      var gob = e.target.closest('.cpm-bgo');
      if (gob) {
        var st = pick && stepOf(counts, pick.key);
        if (gob.closest('.cpm-col') === bcol && st && pick.kind === 'shaft' && tipsWorth(st)) tipStep(); else go();
        return;
      }
      var bl = e.target.closest('a[data-brand]');
      if (bl) {
        clearSel(bl.closest('.cpm-col'));           // "Any flex" tapped: drop any ticks beside it
        hideAbove(level(bl));
        if (!brandStep(bl)) return;                 // no brand data: the link just goes to the results
        e.preventDefault();
        mark(bl, '.cpm-item');
        depth(level(bl) + 1);
        focus();
        return;
      }
      var link = e.target.closest('.cpm-col a[data-open]');
      if (!link) return;
      e.preventDefault();
      clearSel(link.closest('.cpm-col'));           // "Any number" tapped: drop any ticks beside it
      open(level(link) + 1, link.getAttribute('data-open'));   // open THEN mark, or the highlight gets wiped
      mark(link, '.cpm-item');
      depth(level(link) + 1);
      focus();
    });
    menu.addEventListener('change', function (e) {
      if (e.target.type !== 'checkbox' || !counts) return;
      // A club number / flex tick changed: later steps no longer match, so close them.
      if (e.target.closest('.cpm-sel')) {
        var sc = e.target.closest('.cpm-col'), slv = Number(sc.getAttribute('data-level'));
        hideAbove(slv); depth(slv); selButton(sc);
        return;
      }
      // A shaft brand changed while the adapter step is showing: redo the adapter list, keep its ticks.
      if (e.target.closest('.cpm-col') === bcol && !tcol.hidden) {
        var keep = {};
        ticked(tcol).forEach(function (x) { keep[x.value] = 1; });
        if (pick && tipsWorth(stepOf(counts, pick.key))) {
          tipStep();
          tcol.querySelectorAll('input[type=checkbox]').forEach(function (x) { if (keep[x.value]) x.checked = true; });
        } else { tcol.hidden = true; depth(Number(bcol.getAttribute('data-level'))); }
      }
      buttons();
    });
    // Brand search: the listed brands that match, plus any brand hiding inside "Other".
    menu.addEventListener('input', function (e) {
      var pk = e.target.getAttribute && e.target.getAttribute('data-price');
      if (pk) {
        var v = parseFloat(e.target.value);
        price[pk] = isNaN(v) || v < 0 ? null : Math.round(v);
        buttons();
        return;
      }
      if (!e.target.classList.contains('cpm-bsearch')) return;
      var c = e.target.closest('.cpm-col');
      var q = lower(e.target.value || '').replace(/[^a-z0-9]+/g, '');
      var rows = c.querySelectorAll('.cpm-b'), shown = 0;
      for (var i = 0; i < rows.length; i++) {
        var on = rows[i].querySelector('input').checked;
        var unl = rows[i].classList.contains('unl'), oth = rows[i].classList.contains('oth');
        var text = lower(rows[i].querySelector('span').textContent + ' ' + (rows[i].getAttribute('data-a') || '')).replace(/[^a-z0-9 ]+/g, '');
        text = text + ' ' + text.replace(/ /g, '');
        var hide = q === '' ? (unl && !on) : (!on && (oth || text.indexOf(q) < 0));
        rows[i].hidden = hide;
        if (!hide) shown++;
      }
      c.querySelector('.cpm-bnone').hidden = shown > 0;
    });
    menu.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.classList.contains('cpm-bsearch')) e.preventDefault();
      if (e.key === 'Enter' && e.target.hasAttribute('data-price')) {        // Enter in a price box = press Search
        e.preventDefault();
        var gb = e.target.closest('.cpm-col').querySelector('.cpm-bgo');
        if (gb && !gb.disabled) gb.click();
      }
    });

    // Start fetching as soon as the page is on screen (not after every photo
    // has finished), so the menu is ready before anyone taps. A saved copy
    // makes this instant; for a first-time visitor it's a few small downloads.
    GUESS_PAGES = parseInt(menu.getAttribute('data-index-pages'), 10) || 1;
    // The header's Shop dropdown (data-lazy) waits until a shopper heads for
    // "Shop" before downloading anything, so pages without a Shop menu of
    // their own cost nothing extra. Anyone who has been on the home page or a
    // collection page in the last week already has the numbers saved.
    var host = menu.closest('details');
    if (menu.hasAttribute('data-lazy') && host) {
      var warm = function () { ensureData(); };
      ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) { host.addEventListener(ev, warm, { once: true, passive: true }); });
    } else {
      setTimeout(ensureData, 0);
    }
    // data-autoopen="club": opening the dropdown shows the Golf clubs list
    // straight away, like the old list of links did.
    var auto = menu.getAttribute('data-autoopen');
    if (auto && host) {
      host.addEventListener('toggle', function () {
        if (!host.open) return;
        ensureData();
        if (menu.querySelector('.cpm-tile.on')) return;
        var t = menu.querySelector('a.cpm-tile[data-open="' + auto + '"]');
        if (t) openTile(t);
      });
    }
  }

  function boot() {
    var menus = document.querySelectorAll('#cpShopMenu, nav.cpm[data-cpm]');
    for (var i = 0; i < menus.length; i++) if (!menus[i].__cpm) { menus[i].__cpm = true; start(menus[i]); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);   // theme editor
})();
